module.exports = __webpack_public_path__ + "static/media/laya.3369ac5b.png";